<template>
        <div class="view">
          <v-breadcrumbs>
            <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
              >Home</v-breadcrumbs-item
            >
            <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
            <v-breadcrumbs-item :exact="true" :to="{ name: 'accountClosing', params: {} }">
            Account Closing
            </v-breadcrumbs-item>
            <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
            <v-breadcrumbs-item :to="{ name: 'accountClosingView', params: {} }">
              View Account Closing
            </v-breadcrumbs-item>
          </v-breadcrumbs>

          <v-card v-if="loaded">
            <v-card-title>
              View Account Closing
            </v-card-title>
            <v-card-text>
              <v-simple-table>
                <template v-slot:default>
                  <tbody>
                    
          <tr v-if="accountClosing.id">
            <td max-width="35%" class="text-subtitle-1">ID:</td>
            <td>{{ accountClosing.id }}</td>
          </tr>
          
          <tr v-if="accountClosing.closingDate">
            <td max-width="35%" class="text-subtitle-1">Closed Date:</td>
            <td>{{ accountClosing.closingDate }}</td>
          </tr>
          
          <tr v-if="accountClosing.adminUserId">
            <td max-width="35%" class="text-subtitle-1">By User:</td>
            <td>{{ accountClosing.adminUserId }}</td>
          </tr>
          
          <tr v-if="accountClosing.recordedTime">
            <td max-width="35%" class="text-subtitle-1">Created On:</td>
            <td>{{ accountClosing.recordedTime }}</td>
          </tr>
          
                  </tbody>
                </template>
              </v-simple-table>
            </v-card-text>
          </v-card>

          <div class="d-flex justify-space-between ma-5">
            <v-btn @click="goBack">Back</v-btn>
            <v-btn @click="edit(id)" color="primary">Edit</v-btn>
            <span></span>
          </div>
      </div>
    </template>

    <script>
    import { getAccountClosing } from "@/services/accountClosing";
    

    export default {
      data() {
        return {
            id: '',
            accountClosing: {},
            loaded: false,
            relations: {}
        }
      },
      methods : {
        goBack() {
          this.$router.go(-1);
        },
        edit(id) {
          this.$router.push({ name: "accountClosingEdit", params: { id: id }});
        },
        setInstance() {
          this.setDependencies().then( () => {
            getAccountClosing(this.id)
            .then((response) => {
              this.accountClosing = response.data;
              this.loaded = true;
            })
            .catch( () => {
              this.addErrorMessage("Error loading accountClosing");
              this.loaded = true;
            });
          })
        },
        async setDependencies() {
          return null;
        },
        getRelationText(id, relationProperty, relationAttribute) {
          const relationList = this.relations[relationProperty];
          if (relationList) {
            const relationObj = relationList.find(r => r.id == id);
            return relationObj[relationAttribute];
          } else {
            return "";
          }
        }
      },
      created() {
        this.id = this.$route.params.id;
        this.setInstance();
        this.$emit("showParent", false);
      }
    }
    </script>
    